import commonText from './commonContents'


export default {
    ...commonText,
    'uaePassSessionInvalidated': ' ان الجلسة السابقة لم تعد صالحة. يرجى المحاولة مرة أخرى بالنقر على الزر أعلاه',
    "login_heading": "تسجيل الدخول إلى حسابك",
    "login_subheading": "مرحبًا مجددا! يرجى إدخال تفاصيلك",
    "uaeBtnText": "تسجيل الدخول بالهوية الرقمية",
    "orSperatorText": "أو",
    "forgotPasswordLabelText": "نسيت كلمة المرور",
    "submitButtonText": "تسجيل الدخول",
    "auth_unsuccessful": ".يرجى إدخال بريد إلكتروني صحيح",
    "UAEPassLoginCancelled":"ماق مدختسملا ءاغلإب ليجست لوخدلا",
    "UAEPassInvalidCustomerText": "هذه الخدمة مخصصة فقط للمستخدمين المسجلين، يرجى التواصل مع Aldar-800 لتتمكن من الوصول إلى الخدمات",
    "notSOP3Text": "أنت غير مؤهل للوصول إلى هذه الخدمة. إما أن حسابك لم تتم ترقيته أو لديك حساب زائر. يرجى الاتصال بـ Aldar-800 لتتمكن من الوصول إلى الخدمة.",
    "fields": {
        mail: {
            label:"البريد الإلكتروني",
            requiredErrorMessage: commonText.requiredErrorMessage,
            formatErrorMessage: commonText.formatErrorMessage
        },
        password: {
            label: "كلمة المرور",
            requiredErrorMessage: commonText.requiredErrorMessage
        },
        rememberMe: {
            label: "تذكرنى",
            requiredErrorMessage: commonText.requiredErrorMessage
        },
        terms: {
            label: "أوافق على جميع الشروط والأحكام.",
            requiredErrorMessage: commonText.requiredErrorMessage
        },
    }
}

